"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Footer_component_1 = require("./Footer.component");
exports.Footer = Footer_component_1.Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9TY2hvb2xQZXJmb3JtYW5jZVRleGFzL3BhcnRzL0Zvb3Rlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHVEQUF5QztBQUFqQyxvQ0FBQSxNQUFNLENBQUEifQ==